import React from "react";
import { Empty, Spin, Table } from "antd";
import moment from "moment-jalaali";
import { useReportsStore } from "../../../store/slices/createReportsSlice";
import strings from "../../../utils/strings";

const columns = [
      {
          title: "کاربر",
          dataIndex: "CreatorFullName",
          key: "CreatorFullName",
          width: 90,
      },
      {
          title: "توضیحات",
          dataIndex: "Description",
          key: "Description",
          width: 100,
      },
      {
          title: "نوع رویداد",
          dataIndex: "EntityTypeTitle",
          key: "EntityTypeTitle",
          width: 70,
      },
      // {
      //   title: 'وضعیت رویداد',
      //   dataIndex: 'ActionTypeTitle',
      //   key: 'ActionTypeTitle',
      //   width: 20,
      //   render: data => data && strings.currencyFormat(data),
      // },
      {
        title: "تاریخ رویداد",
        dataIndex: "CreationTime",
        key: "CreationTime",
        width: 90,
        render: data => data && strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD  ساعت:  HH:mm'))
      },
    ];

export default function InsuranceShowLogsRequestEvents() {
    const reports = useReportsStore()
    // const faNum = StringHelper.getFarsiNum;
    const data = reports.logsRequestEvent?.data;
    const loading = reports.logsRequestEvent?.loading;
    return (
      <Spin spinning={loading}>
       {data ?
                <Table
                    style={{ overflowX: 'scroll' }}
                    bordered
                    columns={columns}
                    loading={loading}
                    // rowKey="InsuranceRequestId"
                    scroll={true}
                    dataSource={data}
                />
                :
                <Empty description={false} />
            }
      </Spin>
      );
    }